export default function CRMCandidateIco() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="7.5" fill="#EBE1F9" />
      <path
        d="M36 34.6663V32.296C36 30.087 34.4703 28.2309 32.4 27.7046M28.2 13.6776C29.9591 14.3809 31.2 16.0842 31.2 18.0737C31.2 20.0633 29.9591 21.7666 28.2 22.4699M30 34.6663C30 32.4574 30 31.353 29.6346 30.4818C29.1475 29.3202 28.213 28.3973 27.0369 27.9161C26.1548 27.5552 25.0365 27.5552 22.8 27.5552H19.2C16.9635 27.5552 15.8452 27.5552 14.9631 27.9161C13.787 28.3973 12.8525 29.3202 12.3654 30.4818C12 31.353 12 32.4574 12 34.6663M25.8 18.0737C25.8 20.692 23.651 22.8145 21 22.8145C18.349 22.8145 16.2 20.692 16.2 18.0737C16.2 15.4555 18.349 13.333 21 13.333C23.651 13.333 25.8 15.4555 25.8 18.0737Z"
        stroke="#7F56D9"
        stroke-width="2.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
